import PopupFormInvestment from './PopupFormInvestment';
export default PopupFormInvestment;
